
const first_visit_survey = {
	state: {
		form_data: {},
		topic_rows: [],
		hospital_apply_data: {},
	},
	mutations: {
		SET_FORM_DATA (state, data) {
			state.form_data = data
		},
		SET_TOPIC_ROWS (state, data) {
			state.topic_rows = data
		},
		SET_HOSPITAL_APPLY_DATA (state, data) {
			state.hospital_apply_data = data
		},
	},
	actions: {
		setFirstVisitSurveyFormData ({ commit }, data) {
			commit('SET_FORM_DATA', data)
		},
		setFirstVisitSurveyTopicRows ({ commit }, data) {
			commit('SET_TOPIC_ROWS', data)
		},
		setFirstVisitSurveyHospitalApplyData ({ commit }, data) {
			commit('SET_HOSPITAL_APPLY_DATA', data)
		}
	}
};

export default first_visit_survey;